import React from 'react';
import type { ColumnDef } from '@tanstack/react-table';
import type { AvailabilityReportItem } from '@/types';
import { GenericTableSkeleton, createStorageHelpers } from '@/components/shared/GenericTableSkeleton';
import type { GenericTableSkeletonConfig } from '@/components/shared/GenericTableSkeleton';

export const AVAILABILITY_WIDTH_STORAGE_KEY = 'availability_col_max_widths';

const { getStoredWidths, storeColumnWidths } = createStorageHelpers(AVAILABILITY_WIDTH_STORAGE_KEY);
// eslint-disable-next-line react-refresh/only-export-components -- storage helper paired with the skeleton component; splitting needs ~3 import-site updates
export const getStoredAvailabilityWidths = getStoredWidths;
// eslint-disable-next-line react-refresh/only-export-components -- storage helper paired with the skeleton component; splitting needs ~3 import-site updates
export const storeAvailabilityColumnWidths = storeColumnWidths;

const AVAILABILITY_DEFAULT_WIDTHS: Record<string, number> = {
  rowNumber: 40,
  symbol_id: 180,
  sedol: 130,
  isin: 160,
  quantity: 180,
  benchmark_fee: 140,
  ca: 80,
  transfers: 110,
  counterparties: 400,
};

const config: GenericTableSkeletonConfig = {
  storageKey: AVAILABILITY_WIDTH_STORAGE_KEY,
  defaultWidth: 100,
  rowHeight: 39,
  headerRowHeightPx: 41,
  defaultWidths: AVAILABILITY_DEFAULT_WIDTHS,
};

type AvailabilityTableSkeletonProps = {
  columns: ColumnDef<AvailabilityReportItem, unknown>[];
};

export const AvailabilityTableSkeleton: React.FC<AvailabilityTableSkeletonProps> = ({ columns }) => (
  <GenericTableSkeleton columns={columns} config={config} />
);
